import { Navigate } from "react-router-dom";

const ProtectRoute = ({ children, isAllowed, redirect = "/login" }) => {
  if (!isAllowed) {
    return <Navigate to={redirect} />;
  }
  return children;
};

export default ProtectRoute;
